import React, { useEffect, useState } from "react";
import { Globals as OldGlobals } from "../../global/Globals";
import './TermsConditions.css';
import { useDispatch, useSelector } from "react-redux";
import { setIsAgreementChecked, setIsPolicyChecked, removeAllCheck, setIsConfidentialInfoChecked } from "./TermsConditionsSlice";
import { useLanguage } from '../../context/Languagecontext';
const TermsConditions = ({ checkForAgreement, tabIndex1=0 }) => {
    // const [isAgreementChecked, setIsAgreementChecked] = useState(false);
    // const [isPolicyChecked, setIsPolicyChecked] = useState(false);
    const { Globals, languages } = useLanguage();
    const isPolicyChecked = useSelector(state => state.termsConditions.isPolicyChecked);
    const dispatch = useDispatch();
    const openCommissioningProtocol = () => {
        if (languages === OldGlobals.LANGUAGE_KEYS.PORTUGESE) {
            window.open(OldGlobals.FILES.COMMISSIONNING_PROTOCOL_PT, '_blank', 'noopener noreferrer')
        }
        else if (languages === OldGlobals.LANGUAGE_KEYS.AHMARIC) {
            window.open(OldGlobals.FILES.COMMISSIONNING_PROTOCOL_AH, '_blank', 'noopener noreferrer')
        }
        else if (languages === OldGlobals.LANGUAGE_KEYS.KISWAHILI) {
            window.open(OldGlobals.FILES.COMMISSIONNING_PROTOCOL_KW, '_blank', 'noopener noreferrer')
        }
        else {
            window.open(OldGlobals.FILES.COMMISSIONNING_PROTOCOL, '_blank', 'noopener noreferrer')
        }
    }

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;

        if (name === 'agreement') {
            const payload = { isChecked: checked }
            dispatch(setIsAgreementChecked(payload))
        } else if (name === 'policy') {
            const payload = { isChecked: checked }
            dispatch(setIsPolicyChecked(payload))
        }
        else if (name === 'confidential-info') {
            const payload = { isChecked: checked }
            dispatch(setIsConfidentialInfoChecked(payload))
        }
    };


    const openPrivacyNote=()=>{
        window.open(Globals.EXTERNAL_LINKS.PRIVACY_NOTICE_URL, '_blank', 'noopener noreferrer')
    }

    const openExerciseRights=()=>{
        window.open(Globals.EXTERNAL_LINKS.EXERCISE_YOUR_RIGHTS_URL, '_blank', 'noopener noreferrer')
    }
    return (
        <div className="declaration">
            <h3 id="declaration-info" className="declaration-info">{Globals.SIGNUP.DECLRATION_INFO}</h3>
            <div className="decalarationaStatment">
                <div id="declaration-stmt1" className="declaration-stmt">{Globals.SIGNUP.READ_AGREE}<span className="checkbox-link" onClick={openCommissioningProtocol}>{Globals.SIGNUP.COMMISSIONG_PROTOCOL}</span>.</div>
                <div id="declaration-stmt1" className="declaration-stmt">{Globals.SIGNUP.DECLARATION_STMT1}</div>
                <div id="declaration-stmt2" className="declaration-stmt">{Globals.SIGNUP.DECLARATION_STMT2}</div>
            </div>
            <div className="checkbox-container">
                {/* <div className="agreement" style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                        name="agreement"
                        type="checkbox"
                        onChange={handleCheckboxChange}
                        className="checkbox-input"
                    />
                    <label id="checkbox-label" className="checkbox-label">{Globals.SIGNUP.READ_AGREE}<span className="checkbox-link" onClick={openCommissioningProtocol}>{Globals.SIGNUP.COMMISSIONG_PROTOCOL}</span></label>
                </div> */}
                <div className="policy" style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                    tabIndex={tabIndex1}
                        name="agreement"
                        type="checkbox"
                        id="checkbox-input1"
                        onChange={handleCheckboxChange}
                        className="checkbox-input"
                        //checked={isPolicyChecked}
                    />
                    <label id="checkbox-label1" className="checkbox-label1">{Globals.SIGNUP.I_ACCEPT1}<br/>{Globals.SIGNUP.I_ACCEPT_1_1}<label></label><span className="checkbox-link" onClick={openPrivacyNote}>{Globals.SIGNUP.PRIVACY_NOTICE}</span>.</label>
                </div>
                <div className="policy" style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                    tabIndex={tabIndex1}
                        name="policy"
                        type="checkbox"
                        id="checkbox-input2"
                        onChange={handleCheckboxChange}
                        className="checkbox-input"
                        //checked={isPolicyChecked}
                    />
                    <label id="checkbox-label2" className="checkbox-label2">{Globals.SIGNUP.I_ACCEPT2}<br/>{Globals.SIGNUP.I_ACCEPT2_2}<label></label><span className="checkbox-link" onClick={openExerciseRights}>{Globals.SIGNUP.EXERCISE_YOUR_RIGHTS}</span>.</label>
                </div>
                <div className="policy" style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                        <input
                            tabIndex={tabIndex1 + 1}
                            name="confidential-info"
                            type="checkbox"
                            id="checkbox-input2"
                            onChange={handleCheckboxChange}
                            className="checkbox-input"
                        //checked={isPolicyChecked}
                        />
                    </div>
                    <div>
                        <label id="checkbox-label2" className="checkbox-label2">{Globals.SIGNUP.CONFIDENTIAL_INFO}</label>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default TermsConditions;